import { DEFAULT_STUDIO_THEME_COLOR } from '../constants';

const ROUTE_SEPARATOR = '~';
const TEAM_STUDIO_SOURCE_PREFIX = 'team-studio-';

const toPackTitle = (name: string, fallbackTitle: any) => {
  if (!name) {
    return fallbackTitle;
  }

  return {
    en: name,
    zh: name,
    'zh-Hant-HK': name
  };
};

// Route id rules:
// - General hot topic: its own unique id (unchanged, no studio route).
// - General custom hot topic (studio pack under a general hot topic):
//   `c{parentHotTopicId}-{sequence}`, 1-based (e.g. c121-1, c121-2).
// - Team hot topic (classic team items): unchanged.
// - Custom team hot topic: the admin-entered pack id becomes the route id;
//   legacy team packs without an id keep the old index-based route.
export const getStudioPackRouteId = (sourceId: string, packIndex: number, pack?: any) => {
  const source = String(sourceId || '');
  if (source.startsWith(TEAM_STUDIO_SOURCE_PREFIX)) {
    return (pack && pack.id) || `${source}${ROUTE_SEPARATOR}${packIndex}`;
  }
  return `c${source}-${packIndex + 1}`;
};

export const getStudioPackEntries = (source: any): any[] => {
  if (!source) {
    return [];
  }

  const entries: any[] = [];
  const packs = Array.isArray(source.studioPacks) ? source.studioPacks : [];
  packs.forEach((pack: any, packIndex: number) => {
    if (!pack || pack.enabled === false || !Array.isArray(pack.pages) || !pack.pages.length) {
      return;
    }

    entries.push({
      ...source,
      id: getStudioPackRouteId(source.id, packIndex, pack),
      title: toPackTitle(pack.name, source.title),
      studioPackPages: pack.pages,
      studioPackThemeColor: pack.themeColor || DEFAULT_STUDIO_THEME_COLOR,
      studioPackName: pack.name || '',
      studioSourceId: source.id,
      studioPackIndex: packIndex
    });
  });

  return entries;
};

export const findStudioPackEntry = (sources: any[], routeId: string): any | undefined => {
  if (!Array.isArray(sources)) {
    return undefined;
  }

  for (const source of sources) {
    const matched = getStudioPackEntries(source).find(entry => entry.id === routeId);
    if (matched) {
      return matched;
    }
  }

  return undefined;
};
